import { __assign } from 'tslib';
import * as React from 'react';
import Triangle from '../../../../../icons/Triangle.esm.js';
import { BaseLink } from '@invitae/cms-blocks';
import { useAnalyticsEvents } from '@invitae/nucleobase-analytics';
import styles from './NavigationElementL2.module.esm.js';

var NAVL2_ID = 'L2-element-link';
var NavigationElementL2 = function (_a) {
    var link = _a.fields.link, rootElementProps = _a.rootElementProps;
    var _b = (link === null || link === void 0 ? void 0 : link.fields) || {}, analyticsEvents = _b.analyticsEvents, linkScheme = _b.linkScheme, text = _b.text;
    var analyticsProps = useAnalyticsEvents({ analyticsEvents: analyticsEvents });
    var testId = {
        'data-testid': NAVL2_ID,
    };
    return (React.createElement("li", { className: styles.root },
        React.createElement(BaseLink, { classes: { root: styles.link }, fields: linkScheme.fields, id: NAVL2_ID, rootElementProps: __assign(__assign(__assign({}, rootElementProps), analyticsProps), testId) },
            text,
            React.createElement(Triangle, { title: "Go to ".concat(text, " page") }))));
};

export { NavigationElementL2 as default };
//# sourceMappingURL=NavigationElementL2.esm.js.map
